import { Card, Stack, Typography } from '@mui/material';
import PriceSpan from './price-span';

type ItemProps = { title: string; value?: number };

type ListTotalsCardProps = {
  meta: Array<ItemProps>;
};

const Item = ({ title, value }: ItemProps) => {
  return (
    <Stack direction={'row'} gap={4}>
      <Stack direction={'column'}>
        <Typography>{title}</Typography>
        <Typography>
          {value ? <PriceSpan price={value} size="small" /> : '-'}
        </Typography>
      </Stack>
    </Stack>
  );
};

export const ListTotalsCard = ({ meta }: ListTotalsCardProps) => {
  return (
    <Card sx={{ mb: 2, padding: 1, paddingLeft: 2, paddingRight: 2 }}>
      <Stack direction={'row'} gap={8}>
        <Stack direction={'column'}>
          <Typography>Итого:</Typography>
        </Stack>

        {meta.map((item) => (
          <Item key={item.title} title={item.title} value={item.value} />
        ))}
      </Stack>
    </Card>
  );
};
